import { Checkbox, Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { ITrainingActivityType } from '../../../../types/interfaces/training-activity-type';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (item: ITrainingActivityType) => void,
  onDelete: (item: ITrainingActivityType) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.NAME,
      cellReducer: (item: ITrainingActivityType) => {
        return <div className={classes.name}>{item.name}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.NAME_KEY,
      cellReducer: (item: ITrainingActivityType) => {
        return <div className={classes.nameKey}>{item.nameKey}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.MET,
      cellReducer: (item: ITrainingActivityType) => {
        return <div className={classes.met}>{item.met}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.IS_DEFAULT,
      cellReducer: (item: ITrainingActivityType) => {
        return (
          <div className={classes.isDefault}>
            <Checkbox disabled checked={!!item.isDefault} />
          </div>
        );
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (item: ITrainingActivityType) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(item);
                        }}
                      />
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(item);
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
